import styled from 'styled-components';
import { regularWhite } from '../../../../ui-components/design-tokens';
import SvgIcon from '../../../../ui-components/SvgIcon/SvgIcon';

export const StyledTopAreaVariantNoWrap = styled.span`
    white-space: nowrap;
`;

export const StyledTopAreaVariantLink = styled.a`
    color: ${regularWhite};
`;

export const StyledTopAreaVariantIcon = styled(SvgIcon)`
    margin-right: 3px;
`;
